import './style/TermsAgreement.css';
import React from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setUserTosAccepted } from '../../redux/keystoneInterfaceSlice';
import Button from './Button';
import { Text } from '@harperai/materialize-design-system';

const TermsAgreement = () => {
    const dispatch = useDispatch();
    const keystoneInterfaceAccessToken = useSelector((state) => state?.keystoneInterface?.accessToken);

    const handleAgreeToTerms = () => {
        dispatch(setUserTosAccepted({ accessToken: keystoneInterfaceAccessToken }));
    };

    return (
        <div id="keystone-terms-agreement" className="product-vertical-container">
            <div className="product-vertical-container pad-xl v-gap-xl">
                <iframe
                    src="https://www.trymaterialize.com/terms-of-use-embed"
                    title="Terms of Use" />
                <div className="product-horizontal-container space-between align-center">
                    <Text header={2} size="caption" bold={true} variant="secondary">By continuing, you agree to the terms set forth in the document above.</Text>
                    <Button label="Agree" onClick={handleAgreeToTerms} large={true} brand={true} />
                </div>
            </div>
        </div>
    );
};

export default React.memo(TermsAgreement);